////////LIBRARY/////////
import moment from 'moment'

let endDay = moment().endOf('day').toDate()

let startDay = moment().subtract(7, 'days').startOf('day').toDate()

const initialState = {
	globalLoading: {
		loading: false,
		count: 0,
	},
	columns: {
		col: [],
		height: 0,
		isValidateEnable: false,
		isEditingTrigger: false,
		isResetForm: false,
		formButtonWidth: 0,
		isSingleEdit: false,
		isSearchfieldUpdated: false,
		currentColumn: '',
		currentDir: '',
	},
	modal: {
		key: false,
		title: '',
		level: '',
		show: false,
		errorMsgParams: [],
		path: '',
		insideModalResponse: false,
	},
	error: {
		status: '',
		msg: '',
	},
	user: {
		isLoading: false,
		error: {},
		identity: {
			kioskSelected: {},
			preferedLanguage: {},
			idPerimeter: 0,
		},
		forgotPassword: {
			status: 0,
			isLoading: false,
			error: false,
		},
		forgotLogin: {
			status: 0,
			isLoading: false,
			error: false,
		},
		isConnected: false,
		familySelected: {},
		path: false,
		datePicker: {
			startDate: startDay,
			endDate: endDay,
		},
		tableReferential: [],
	},
	languages: {
		items: [],
		translations: {},
		isLoading: false,
		error: false,
		scope: '',
		selectedLanguage: null,
		newLanguageSelected: null,
	},
	usersManager: {
		isLoading: false,
		userLogin: '',
		error: false,
		paging: {},
		items: [],
		header: {},
		companyId: {},
	},
	userDetail: {
		isLoading: false,
		error: false,
		items: false,
		update: false,
	},
	rolesManager: {
		isLoading: false,
		error: false,
		items: [],
		roleDetail: false,
	},
	tagsManager: {
		isLoading: false,
		error: false,
		items: [],
		tagDetail: {
			users: false,
			kiosks: false,
		},
	},
	toastSuccess: {
		show: false,
		trackClick: 0,
		successMsgParams: '',
		nextMessage: '',
		tamponClose: '',
		path: '',
	},
	myAccount: {
		isLoading: false,
		error: false,
		items: {},
		update: false,
	},
	kioskPerimeter: {
		isLoading: false,
		error: false,
		items: [],
		kioskPerimeterDetail: false,
		deleteSuccess: false,
		isUpdatedPerimeter: false,
	},
	recapStock: {
		isLoading: false,
		error: false,
		items: [],
		paging: {},
		header: {},
		columnsTable: {},
		filtersInfos: {},
	},
	salesHistoryManager: {
		isLoading: false,
		error: false,
		items: [],
		header: {},
		paging: {},
		transactionNumber: {},
	},
	scheduledPricesManager: {
		isLoading: false,
		error: false,
		items: [],
		header: {},
		paging: {},
		transmission: [],
		campaign: {},
	},
	scheduledPromoManager: {
		isLoading: false,
		error: false,
		items: [],
		header: {},
		paging: {},
		transmission: [],
		campaign: {},
		promotionNumber: {},
	},
	campaignPrice: {
		isLoading: false,
		error: false,
		campaign: {},
		update: false,
		isSuccess: false,
	},
	campaignPromo: {
		isLoading: false,
		error: false,
		campaign: {},
		update: false,
		isSuccess: false,
	},
	pricesManagerByArticle: {
		isLoading: false,
		error: false,
		items: [],
		header: {},
		paging: {},
		campaign: {},
	},

	consignation: {
		isLoading: false,
		error: false,
		items: {},
		customer: {},
		paging: {},
		header: {},
		update: false,
		contractSend: false,
		contractView: false,
		transactionNumber: {},
		isUpdated: false,
	},
	kioskPricesManager: {
		isLoading: false,
		error: false,
		items: [],
		header: {},
		paging: {},
		transmission: [],
		campaign: {},
	},
	rgpd: {
		isLoading: false,
		error: false,
		items: [],
		header: {},
		paging: {},
		status: 0,
	},

	logUsers: {
		isLoading: false,
		error: false,
		items: [],
		header: {},
		paging: {},
	},
	logKiosk: {
		isLoading: false,
		error: false,
		items: [],
		header: {},
		paging: {},
	},
	logSynchro: {
		isLoading: false,
		error: false,
		items: [],
		header: {},
		paging: {},
	},
	logExtranet: {
		isLoading: false,
		error: false,
		items: [],
		header: {},
		paging: {},
	},
	telecollectManager: {
		isLoading: false,
		error: false,
		items: [],
		header: {},
		paging: {},
		telecollectDetail: {},
		telecollectDetailItems: {
			included: [],
			excluded: [],
			header: {
				included: {},
				excluded: {},
			},
		},
		telecollectId: {},
		sale: [],
		telecollectTicket: {},
	},
	salesHistoryByCodes: {
		isLoading: false,
		error: false,
		items: [],
		header: {},
		paging: {},
		itemCatalog: {},
	},
	salesByArticleHistoryManager: {
		error: false,
		isLoading: false,
		items: [],
		header: {},
		paging: {},
		itemCatalog: {},
	},
	distributionGroupRepository: {
		isLoading: false,
		error: false,
		paging: {},
		items: {},
		header: {},
		deleteSuccess: false,
		update: false,
	},
	isRedirect: {
		isLoading: false,
		isPrevious: false,
	},
	articleManager: {
		isLoading: false,
		error: false,
		item: false,
		update: false,
		availableOptions: [],
	},
	addItemCatalog: {
		isLoading: false,
		error: false,
		paging: {},
		items: false,
		header: {},
		isUpdated: false,
		errorUnlink: {},
	},
	tooltipHelp: {
		showModal: false,
		content: '',
		insideModal: false,
	},
	companiesManager: {
		isLoading: false,
		error: false,
		paging: {},
		items: {},
		header: {},
	},
	companyDetail: {
		isLoading: false,
		error: false,
		item: false,
		update: false,
		availableOptions: [],
		distributionGroupChecked: {},
		distributionChecked: {},
		maintainerChecked: {},
	},
	translationsManager: {
		isLoading: false,
		error: false,
		paging: {},
		items: {},
		header: {},
	},
	exportData: {
		isLoading: false,
		error: false,
		item: false,
		isExported: false,
	},
	userPreferences: {
		isLoading: false,
		error: false,
		items: {},
		isActived: {
			bool: true,
		},
	},
	notifications: {
		isLoading: false,
		error: false,
		items: [],
	},
	articleLifeManager: {
		isLoading: false,
		error: false,
		data: [],
		header: {},
		isUpdate: false,
		timelineData: [],
		timelineLegend: [],
	},
	headerCarousel: {
		active: -1,
	},
	initKioskBusinessManager: {
		isLoading: false,
		error: false,
		paging: {},
		items: [],
		header: {},
		isKioskUpdated: false,
	},
	initKioskCustomerManager: {
		isLoading: false,
		error: false,
		paging: {},
		items: [],
		header: {},
	},
	initKioskCreation: {
		statusId: 0,
		requestId: null,
		forceReadOnly: false,
		definition: {
			availableOptions: {},
			data: {},
			idCompanyCreated: null,
			rsCompanyCreated: null,
		},
		bankDetails: {
			availableOptions: {},
			data: {},
		},
		addItems: {
			availableOptions: {},
			errorUnlink: {},
			data: {
				headerContent: {
					contentPagined: {
						content: [],
					},
				},
			},
			isUpdated: false,
		},
		addPrices: {
			availableOptions: {},
			data: {},
		},
		initKioskImplantation: {
			availableOptions: {},
			data: {
				headerContent: {
					contentPagined: {
						content: [],
					},
				},
			},
			catalog: {},
			isUpdate: false,
			storedDatas: [],
		},
		summary: {
			data: {},
			isUpdated: false,
		},
		isLoading: false,
		error: false,
	},
	kioskProductionList: {
		isLoading: false,
		error: false,
		paging: {},
		items: [],
		header: {},
		modalInfo: { simCard: null, battery: null, ws: null },
		labelToDisplay: null,
	},
	kioskDiagnostic: {
		isLoading: false,
		error: false,
		paging: {},
		items: [],
		header: {},
		pageTitleParam: {},
	},
	itemCatalog: {
		isLoading: false,
		error: false,
		paging: {},
		items: [],
		header: {},
		item: {},
		itemGenerateCode: [],
		isClosedModal: false,
		toUpdated: false,
	},
	itemCatalogDetail: {
		isLoading: false,
		error: false,
		itemsDetail: {},
	},
	kioskEditSetUp: {
		isLoading: false,
		error: false,
		itemDetail: {},
	},
	kioskRacksRequest: {
		isLoading: false,
		error: false,
		item: {},
		options: {},
		isUpdated: false,
	},
	kioskEditImplantation: {
		availableOptions: {},
		data: {
			headerContent: {
				contentPagined: {
					content: [],
				},
			},
		},
		catalog: {},
		isUpdate: false,
		isLoading: false,
		error: false,
	},
	languagesManager: {
		isLoading: false,
		error: false,
		paging: {},
		items: [],
		header: {},
	},
	languageDetail: {
		isLoading: false,
		error: false,
		items: false,
		update: false,
	},
	table: {
		savedColumnsDisplay: {
			idPageTable: null,
			labelPageTable: null,
			columnPreference: [],
		},
		error: false,
		isLoading: false,
		isFromRedirect: false,
	},
	salesControl: {
		isLoading: false,
		error: false,
		paging: {},
		items: [],
		header: {},
	},
	exportDataByEmail: {
		isLoading: false,
		status: 'idle', // 'idle' | 'success' | 'error'
	},
}

export default initialState
